import type { PropsWithChildren } from 'react';

import { Link } from '@remix-run/react';

type Props = PropsWithChildren<{
  href?: string;
}>;

const UpgradePageLink = ({ href, children }: Props) => {
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }

  return (
    <Link to={'/upgrade'} prefetch="intent">
      {children}
    </Link>
  );
};

export default UpgradePageLink;
